import { Link } from "react-router-dom";
import { ButtonLink } from "@/components/ButtonLink";
import { LanguageSwitch } from "@/components/LanguageSwitch";
import { Wordmark } from "@/components/Wordmark";
import { useLocale } from "@/locale/LocaleContext";
import shell from "@/components/shell.module.css";
import ui from "@/components/ui.module.css";

export function NotFoundPage() {
  const { m } = useLocale();
  return (
    <div className="app-frame fade-in">
      <header className={shell.top}>
        <Wordmark />
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <LanguageSwitch />
          <Link to="/login">{m.common.signIn}</Link>
        </div>
      </header>
      <main id="main" className={shell.main} style={{ maxWidth: 28 * 16 }}>
        <p className={ui.meta}>{m.notFound.code}</p>
        <h1 className={shell.pageTitle}>{m.notFound.title}</h1>
        <p className={shell.pageLead}>{m.notFound.body}</p>
        <div className={ui.actions} style={{ justifyContent: "flex-start" }}>
          <ButtonLink to="/" variant="primary">
            {m.notFound.home}
          </ButtonLink>
          <ButtonLink to="/login" variant="secondary">
            {m.common.signIn}
          </ButtonLink>
        </div>
      </main>
      <footer className={shell.footerPublic}>
        <Link to="/privacy">{m.common.privacy}</Link>
        <Link to="/terms">{m.common.terms}</Link>
      </footer>
    </div>
  );
}
